import { request } from '../../helpers/request';


export function getMapTours(types, search) {
    let tours = request.get(`/map`, {
        params: {
            filters: types,
            search
        }
    })
        .then(res => res.data);
    return tours;
}

export function getMapTourDetailsById(id) {
    let tour = request.get(`/details/${id}`)
        .then(res => res.data);
    return tour;
}